export const config = {
   backEnd: process.env.REACT_APP_API_ENDPOINT
};